// extracted by mini-css-extract-plugin
export default {"footerLogoLink":"footerLogoLink_zxYv"};